import React from "react";
import { createRoot } from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { msalConfig } from "./config/auth";
import './index.css';

const IS_MOCK = import.meta.env.VITE_USE_MOCK_API === 'true';

const getMsalConfig = () => {
  if (!IS_MOCK) {
    return msalConfig;
  }

  return {
    ...msalConfig,
    auth: {
      ...msalConfig.auth,
      clientId: msalConfig.auth.clientId || 'mock-client-id',
      redirectUri: globalThis.location.origin,
      postLogoutRedirectUri: globalThis.location.origin,
    },
  };
};

async function bootstrap() {
  const container = document.getElementById("root")!;
  const msalInstance = new PublicClientApplication(getMsalConfig());

  if (!IS_MOCK) {
    await msalInstance.initialize();
  }

  createRoot(container).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

bootstrap().catch((e) => {
  console.error("MSAL bootstrap failed", e);
});